import { Instagram, Facebook } from "lucide-react";
import { SITE, NAV } from "../../data/site";
import { useBooking } from "./BookingModal";
import { useLang } from "../../i18n/LanguageContext";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = () => {
  const { openBooking } = useBooking();
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="bg-foreground text-background py-16"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-10 items-start">
          <div>
            <img src="/logo-sand.png" alt="Tribe Beach Lounge logo" className="h-12 w-auto" />
            <p className="mt-4 text-background/50 font-light max-w-xs">
              {t.footer.motto}. {t.hero.location}.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`footer-nav-${n.id}`}
                onClick={() => scrollTo(n.id)}
                className="text-sm text-background/70 hover:text-accent transition-colors"
              >
                {t.nav[n.id]}
              </button>
            ))}
          </div>

          <div className="md:text-right">
            <button
              data-testid="footer-book-now"
              onClick={openBooking}
              className="inline-flex items-center bg-accent text-accent-foreground text-xs uppercase tracking-luxe px-6 py-3 hover:bg-background hover:text-foreground transition-colors"
            >
              {t.common.book}
            </button>
            <div className="mt-5 flex gap-4 md:justify-end">
              <a
                data-testid="footer-instagram"
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-background/70 hover:text-accent transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                data-testid="footer-facebook"
                href={SITE.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-background/70 hover:text-accent transition-colors"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background/10">
          <p data-testid="footer-seo-text" className="text-xs leading-relaxed text-background/40 max-w-3xl">
            {t.footer.seo}
          </p>
          <div className="mt-6 text-xs text-background/40 flex flex-col md:flex-row justify-between gap-3">
            <span>© {new Date().getFullYear()} {SITE.name}. {t.footer.rights}</span>
            <span>{t.footer.motto}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
